<template>
  <!-- Destaque acima de 72h é só visual (D23): sem aviso ativo ao gestor (D68). -->
  <span
    v-if="hours !== null"
    class="inline-flex items-center gap-1 text-[12px] leading-4 whitespace-nowrap"
    :class="overdue ? 'text-alert font-bold' : 'text-[#52526f]'"
    :title="overdue ? 'Aguardando há mais de 72h' : undefined"
    data-testid="waiting-since"
  >
    <svg viewBox="0 0 24 24" class="w-3.5 h-3.5 shrink-0" aria-hidden="true">
      <path :d="overdue ? mdiClockAlertOutline : mdiClockOutline" fill="currentColor" />
    </svg>
    aguardando {{ formatWaiting(hours) }}
  </span>
  <span v-else class="text-[12px] text-[#7f7f8e]">—</span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { mdiClockAlertOutline, mdiClockOutline } from '@mdi/js'

import { formatWaiting, isWaitingOverdue, waitingHours } from '../model'

const props = defineProps<{ since: string | null }>()

const hours = computed(() => waitingHours(props.since))
const overdue = computed(() => isWaitingOverdue(hours.value))
</script>
